import { User } from 'contexts/AuthContext';

export default function formatUserName(user: User) {
  return `${user.first_name} ${user.last_name}`.trim();
}
